import React from "react";

import UpdateWarehouse from "../components/warehouses/UpdateWarehouse";
import Navbar from "../components/homePage/navBar";

const UpdateWarehousePage: React.FC = () => {
  return (
    <div>
      <Navbar />
      <UpdateWarehouse />
    </div>
  );
};

export default UpdateWarehousePage;
